"use client";
// See the following for why this is currently needed:
// https://github.com/vercel/next.js/issues/85604
// https://github.com/vercel/next.js/issues/85604#issuecomment-3500855611
// https://github.com/vercel/next.js/issues/85604#issuecomment-3510327325
// https://github.com/vercel/next.js/issues/91254

// TODO: Remove when https://github.com/vercel/next.js/issues/85604 is fixed

import NextLink from "next/link";
import { chakra } from "@chakra-ui/react";

const CustomNextLink = chakra(NextLink);

export default CustomNextLink;
